import { Authorized } from '@components/ui';
import { showNotification } from '@helpers/notification-helper';
import ProviderCreateForm from '@pages/provider/create-provider/components/provider-create-form';
import React from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { TAuthority } from 'types/authority.types';
import { CreateProviderSC } from './create-provider.styled';

const CREATE_AUTH: TAuthority[] = ['providerManagementEdit'];

const CreateProvider: React.FunctionComponent = () => {
  const { replace, goBack } = useHistory();
  const { formatMessage } = useIntl();

  const afterSubmit = React.useCallback(() => {
    showNotification({
      type: 'SUCCESS',
      copy: '',
      title: formatMessage({ id: 'provider.onboarding.form.success' }),
    });
    replace('/my-profile/providers');
  }, []);

  return (
    <CreateProviderSC onBack={goBack}>
      <Authorized authority={CREATE_AUTH}>
        <ProviderCreateForm canGoBack={false} afterSubmit={afterSubmit} />
      </Authorized>
    </CreateProviderSC>
  );
};

export default React.memo(CreateProvider);
